import { useEffect, useRef } from "react";

type CallbackFunction = () => Promise<void>;

// intervalo de 10 segundos
const REFETCH_GET_BIOMETRY_ANALYSIS_STATUS_INTERVAL = 10 * 1000;

export const useInterval = (callback: CallbackFunction, interval?: number): void => {
	const savedCallback = useRef<CallbackFunction | null>(null);
	const delay = interval || REFETCH_GET_BIOMETRY_ANALYSIS_STATUS_INTERVAL;

	useEffect(() => {
		if (savedCallback.current) {
			savedCallback.current();
		}
	}, []);

	useEffect(() => {
		savedCallback.current = callback;
	}, [callback]);

	useEffect(() => {
		const tick = (): void => {
			if (savedCallback.current) {
				savedCallback.current();
			}
		};

		const id = setInterval(tick, delay);

		return () => {
			clearInterval(id);
		};
	}, [delay]);
};
